const teamMembers = [
  {
    name: "Aaron Venema",
    pictureURL: "/assets/aaron.jpg",
    bio: "Drawing on my background in engineering, my passion for language learning, and my talent for front-end web development, I offer a unique combination of technical and creative skills to any project. My focus is on creating visually stunning and user-friendly websites that meet the needs of both clients and users, and I am committed to delivering high-quality results every time.",
    website: "aaronvenema.com",
    websiteHref: "https://aaronvenema.com/",
    github: "https://github.com/anonymous-a-rod",
    linkedIn: "https://www.linkedin.com/in/aaron-venema-a4797354/",
    id: 1,
  },
  {
    name: "Alex Hessler",
    pictureURL: "/assets/alex.jpg",
    bio: "I'm a Web Developer who is never done learning, developing and growing. My strongest focuses revolve around team cohesiveness and the removal of all barriers for any potential challenges.",
    website: "alexrhessler.com",
    websiteHref: "https://alexrhessler.com/",
    github: "https://github.com/alex-hessler",
    linkedIn: "https://www.linkedin.com/in/alex-hessler-8b378a252/",
    id: 2,
  },
  {
    name: "Cliffton James",
    pictureURL: "/assets/cliffton.jpg",
    bio: "Web developer that is  passionate about creating compelling and user-friendly web applications. In addition to my technical skills, I am also a creative content creator, a team player, and a continuous learner who is always seeking new opportunities to grow and improve.",
    website: "jamcliffporfolio",
    websiteHref: "https://jamcliffprofolio.space/?nocache=1",
    github: "https://github.com/cliff82",
    linkedIn: "https://www.linkedin.com/in/cliffton-james-02a8197b/",
    id: 3,
  },
  {
    name: "Kamil Watson",
    pictureURL: "/assets/kamil.jpg",
    bio: "I'm a BUILDER. Some use hammers & nails. I use keystrokes to CREATE SOLUTIONS that make the world a little more enjoyable. I'm a UI/UX Designer with nice coding SKILLZ (Javascript, React, Tailwind CSS and more). I'm highly motivated, creative, and versatile. Specializing in creating for mom & pops and new start-up builds.",
    website: "SayHelloToKam",
    websiteHref: "https://sayhellotokam.com",
    github: "https://github.com/SayHelloToKam",
    linkedIn: "https://www.linkedin.com/in/kamilwatson/",
    id: 4,
  },
  {
    name: "Kelsey Jackson",
    pictureURL: "/assets/kelsey.jpg",
    bio: "I am a passionate individual focused on front end web development. I love to use code to bring out my inner creativity. Self-learning is a trait I've embraced and I enjoy absorbing as much as I can to bring out the best in myself and others.",
    website: "kelsey-jackson.com",
    websiteHref: "https://kelsey-jackson.com/",
    github: "https://github.com/kelso540",
    linkedIn: "https://www.linkedin.com/in/kelsey-jackson-22b098256/",
    id: 5,
  },
  {
    name: "Michael Plantamura",
    pictureURL: "/assets/michael.jpg",
    bio: "Air Force Veteran and Frontend Software Engineer with a bachelor's degree in Criminal Justice from Stockton University. ",
    website: "michaelplant",
    websiteHref: "https://michaelplant.netlify.app/",
    github: "https://github.com/Michaelplant2",
    linkedIn: "https://www.linkedin.com/in/michael-plantamura-458347223/",
    id: 6,
  },
];

export default teamMembers;
